import React from "react";
import propTypes from "prop-types";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";

export default function CartItem(props) {
  let eTooltipText = "Editorial/Clip Show Use";
  let aTooltipText = "";
  let aTooltipText2 = "";
  let iconColor = "";

  if (props.aci === "YELLOW") {
    aTooltipText = "Inquire for Advertising Use";
    iconColor = "yellow";
  } else if (props.aci === "GREEN") {
    aTooltipText = "Advertising Use";
    aTooltipText2 =
      "Talent releases on file for all on-camera participants; inquire regarding trademark and other releases.";
    iconColor = "green";
  } else if (props.aci === "YELLOW") {
    aTooltipText = "Inquire for Advertising Use";
    iconColor = "yellow";
  } else if (props.aci === "RED") {
    aTooltipText = "Not for Advertising Use";
    iconColor = "red";
  }

  return (
    <div className="cart-item">
      <div className="inquiry-img-container">
        <Link to={`/licensing/view/${props.jmId}`}>
          <img
            className="img-bg"
            src={props.imgUrl}
            alt={props.publishingTitle}
          />
          <div className="inquiry-label">Inquiry</div>
          <img src={props.imgUrl} alt={props.publishingTitle} />
        </Link>
      </div>
      <h5>
        <Link to={`/licensing/view/${props.jmId}`}>
          {props.publishingTitle}
        </Link>
      </h5>
      <p>
        JV# <span>{props.jmId}</span>
      </p>
      <div className="clearance">
        <Tooltip title={eTooltipText} placement="bottom">
          <div className="add-left green">E</div>
        </Tooltip>

        <Tooltip title={aTooltipText + " " + aTooltipText2} placement="bottom">
          <div className={iconColor}>A</div>
        </Tooltip>
      </div>
    </div>
  );
}

CartItem.propTypes = {
  jmId: propTypes.string,
  imgUrl: propTypes.string,
  publishingTitle: propTypes.string,
  aci: propTypes.string,
};
